import React from "react";
import { RotationInputProps } from "../../Types/types";

const RotationInput: React.FC<RotationInputProps> = ({
  rotation,
  setRotation,
  label,
}) => {
  return (
    <div className="mb-2 relative">
      <label htmlFor="rotation" className="block mb-1 text-base ml-2">
        {label}
      </label>
      <div className="relative">
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          id="rotation"
          className="w-full pl-3 pr-3 py-2 rounded-md border border-gray-300 shadow-sm focus:outline-none focus:ring-0 dark:bg-darkBackground dark:border-purple"
          value={rotation || ""}
          onChange={(e) =>
            setRotation(e.target.value === "" ? 0 : Number(e.target.value))
          }
        />
      </div>
    </div>
  );
};

export default RotationInput;
